import {
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonFooter,
  IonHeader,
  IonToolbar,
  IonModal,
  IonButtons,
  IonIcon,
  IonTitle,
  IonSegment,
  IonSegmentButton,
} from "@ionic/react";
import { chevronBack, trashOutline, businessOutline, idCardOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { User } from "../../../@types/user";
import { UserProfileSearchBar } from "./UserProfileSearchBar";
import { RootState } from "../../../store/rootReducer";
import {clearSelectedUsers, setSearchText } from "../../../store/profileDetail/profileDetail.reducer";
import { removeUserFromProfile } from "../../../store/profileDetail/actions/removeUserFromProfile";
import { addUserToProfile } from "../../../store/profileDetail/actions/addUserToProfile";
import { selectUsersAvailable } from "../../../store/profileDetail/selector/selectUsersAvailable";
import { selectUsersSelected } from "../../../store/profileDetail/selector/selectUsersSelected";
import { AddUserSelector } from "./AddUserSelector";
import { AddUserSelected } from "./AddUserSelected";

export const ProfileSegmentUsers: React.FC = () => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectorActive, setSelectorActive] = useState<boolean>(true);
  const userList: User[] = useSelector((state: RootState) => state.profileDetail.userList);
  const usersAvailable: User[] = useSelector(selectUsersAvailable);
  const usersSelected: User[] = useSelector(selectUsersSelected);

  useEffect(() => {
    dispatch(setSearchText(""));
  }, [dispatch]);

  const updateProfileUsers = () => {
    if (usersSelected.length > 0) {
      usersSelected.map(async (user: User) => await dispatch(addUserToProfile(user)));
      dispatch(clearSelectedUsers());
      setShowModal(false);
      setSelectorActive(true);
    } else {
      return;
    }
  };
  return (
    <>
      <IonList class="ion-no-padding">
        <UserProfileSearchBar />
        {userList.length > 0 ? (
          <>
            {userList.map((item) => (
              <IonItem key={item?.id}>
                <IonLabel>
                  <h2>{item?.name}</h2>
                  <p>{item?.email}</p>
                  <p>{item?.username}</p>
                </IonLabel>
                {/* Boton que lleva a la asignación de organizations al perfil del usuario. */}
                <IonButton routerLink={`/app/tic/perfiles/asigna-cliente/${item?.id}`} >
                  <IonIcon icon={idCardOutline} />
                </IonButton>
                {/* Boton que lleva a la asignación de locations al perfil del usuario. */}
                <IonButton routerLink={`/app/tic/perfiles/asigna-instalacion/${item?.id}`} >
                  <IonIcon icon={businessOutline} />
                </IonButton>
                {/* Boton que remueve al usuario del perfil */}
                <IonButton onClick={() => dispatch(removeUserFromProfile(item))}>
                  <IonIcon icon={trashOutline} />
                </IonButton>
              </IonItem>
            ))}
          </>
        ) : (
          <IonItem>No se encontraron resultados.</IonItem>
        )}
      </IonList>
      <IonFooter>
        <IonButton onClick={() => setShowModal(true)}>Agregar Usuario</IonButton>
      </IonFooter>

      <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => {
                dispatch(clearSelectedUsers());
                setShowModal(false);
                setSelectorActive(true);
              }}>
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonButtons slot="end">
              {usersSelected.length > 0 && (
                <IonButton onClick={() => updateProfileUsers()}>Guardar</IonButton>
              )}
            </IonButtons>
            <IonTitle>Gestionar usuarios</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonSegment
          value={selectorActive ? "disponibles" : "seleccionados"}
          color="secondary"
          style={{ maxWidth: '100%', position: 'fixed', bottom: 0, left: 0, backgroundColor: 'white', zIndex: 1000 }}
        >
          <IonSegmentButton value="disponibles" onClick={() => { setSelectorActive(true) }}>
            <IonLabel>Disponibles</IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="seleccionados" onClick={() => { setSelectorActive(false) }}>
            <IonLabel>Seleccionados ({usersSelected.length})</IonLabel>
          </IonSegmentButton>
        </IonSegment>
        {selectorActive ? (
          <AddUserSelector />
        ) : (
          <AddUserSelected />
        )}
        <IonFooter style={{ height: '2rem' }} className="ion-no-border">
        </IonFooter>
      </IonModal>
    </>
  );
};
